import { React, useState } from "react";
import Feedback from "./Components/Feedback/Feedback";

import "./App.css";
import Social_Events from "./Components/Social_Events/Social_Events";
import "./App.css";
import Description from "./Components/Description/description";

import Landing from "./Components/Landing_Page/landing";
import "./App.css";
import PreviousAssociations from "./Components/previousAssociations/PreviousAssociationTrying";
import ContactUs from "./Components/ContactUs/ContactUs";
import Team from "./Components/Team/Team";
import Donatebutton from "./Components/DonateButton/Donatebutton";
import Footer from "./Components/Footer/foo";

function App() {
  return (
    <>
        <div className="App app-2">
          <Landing />
          <Description />
          <PreviousAssociations />
          <Feedback />
          <Team />
          <Donatebutton />
        </div>
    </>
  );
}

export default App;
